import update from 'immutability-helper/index';
import {
    CLEAR_PAGE_SEARCH_FILTER,
    FETCHED_PAGES,
    PAGE_SEARCH_BY_TITLE
} from './types';

export default function(
    state = {
        pageSearchCriteria: '', 
        allPagesBySearchCriteria: [] 
    }, action) {
    switch(action.type) {

        case FETCHED_PAGES:

            return update(state, {
                allPagesBySearchCriteria: {$set: action.pages},
            });

        case PAGE_SEARCH_BY_TITLE:

            return update(state, {
                pageSearchCriteria: {$set: action.payload},
            });

        case CLEAR_PAGE_SEARCH_FILTER:

            return update(state, {
                allPagesBySearchCriteria: {$set: []},
                pageSearchCriteria: {$set: ''}
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/page-picker/reducer.js